"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processQuestionGrouping = void 0;
const _1 = require(".");
const create_incrementer_1 = require("./create-incrementer");
const create_ordinal_1 = require("./create-ordinal");
const process_scope_1 = require("./process-scope");
const processQuestionGrouping = ({ group, ordinal, conditions, formId, ordinals, }) => {
    const ordinalIncremeneter = (0, create_incrementer_1.createIncrementer)();
    if (!group.title && !group.subtitle) {
        return null;
    }
    group.content = group.content.map((entity) => (Object.assign(Object.assign({}, entity), { id: (0, create_incrementer_1.getNextQuestionId)() })));
    ordinal(group);
    return {
        id: group.id,
        uniqueKey: group.uniqueKey,
        title: group.title,
        subtitle: group.subtitle,
        layout: group.layout,
        questions: {
            connectOrCreate: group.content
                .flat(Infinity)
                .map((q) => {
                if (!q.question) {
                    console.log(q);
                }
                return (0, _1.processQuestion)({
                    question: q,
                    ordinal: () => (0, create_ordinal_1.createOrdinal)(q, ordinalIncremeneter(), (0, process_scope_1.processScope)("GROUP", group.id), ordinals),
                    ordinalIncremeneter,
                    conditions,
                    formId,
                    value: "GROUP",
                    scopeEntityId: group.id,
                    ordinals,
                });
            })
                .flat()
                .filter((q) => Boolean(q)),
        },
    };
};
exports.processQuestionGrouping = processQuestionGrouping;
